import styled from "@emotion/styled";
import { Table } from "@mantine/core";

export const StyledPreTextTable = styled(Table)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.main[9]};
`;

export const ReadonlyFieldset = styled.fieldset`
  display: contents;

  &[disabled] {
    pointer-events: none;
  }

  &[disabled] input,
  &[disabled] textarea,
  &[disabled] select {
    background-color: #f0f0f0 !important;
    color: #333 !important;
    opacity: 1 !important;
  }

  &[disabled] input::placeholder,
  &[disabled] textarea::placeholder {
    color: #666 !important;
    opacity: 1 !important;
  }
`;
